<template>
  <BaseModal :modalTitle="$t('area.business-central.item-mapping.dev-tools.title')">
    <template #titleBadge>
      <DevBadge />
    </template>

    <UiBaseFormVee
      :errorText="errorText"
      :onSubmit="onSubmit">
      <div class="mb-3 flex flex-col gap-3">
        <p>
          {{
            $t(
              'W: Opretter en testvare i BC for hver analyse, hastetillæg og tillægsydelse uden varenummer, og skriver nummeret ind i opsætningen.'
            )
          }}
        </p>
        <span
          v-if="resultMessage"
          class="text-sm text-text-secondary">
          {{ resultMessage }}
        </span>
      </div>

      <template #buttons>
        <UiBaseButton
          :text="$t('area.business-central.item-mapping.dev-tools.create-test-items')"
          :isLoading="isLoading"
          type="submit" />
      </template>
    </UiBaseFormVee>
  </BaseModal>
</template>

<script lang="ts">
import { useToast } from '@/globals/typescript/utils/toast'
import type { PropType } from 'vue'

export default {
  name: 'CreateTestBcItemsModal',

  props: {
    onConfirm: { type: Function as PropType<() => Promise<string>>, required: true },
  },

  data() {
    return {
      isLoading: false,
      resultMessage: '',
      errorText: '',
    }
  },

  methods: {
    async onSubmit(): Promise<void> {
      this.errorText = ''
      this.isLoading = true
      try {
        this.resultMessage = await this.onConfirm()
      } catch (err) {
        this.errorText = err instanceof Error && err.message ? err.message : this.$t('error.common.standard')
        useToast().error(this.errorText)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
